import React, { useEffect, useState } from "react";
import { getNews } from "../../../api/postApi";

import styled from "styled-components";
import NewsCard from "./News/NewsCard";
import PageHeader from "../../common/PageHeader";
import { useAlertStore, useUserStore } from "@/store/userStore";
import SeoHead from "@/components/common/SeoHead";

interface NewsDataProps {
  date: string;
  description: string;
  img: string;
  link: string;
  title: string;
}

const Div = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  h2 {
    margin-bottom: 12px;
  }
  button {
    align-self: flex-end;
    background-color: #49b736;
    font-size: 16px;
    font-weight: 400;
    color: white;
    padding: 12px 40px;
    border: none;
    cursor: pointer;
    margin-bottom: 60px;
    @media (max-width: 1024px) {
      padding: 10px 15px;
      font-size: 14px;
      margin-bottom: 20px;
    }
  }
`;
const Section = styled.section`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;

  margin-top: 70px;
  margin-bottom: 120px;
  @media (max-width: 1024px) {
    flex-wrap: nowrap;
    flex-direction: column;
    margin-top: 0;
  }
`;
export default function NewsPage() {
  const { showAlert } = useAlertStore();
  const [newsList, setNewsList] = useState<NewsDataProps[]>([]);
  const { role } = useUserStore();

  const fetchNews = async () => {
    const res = await getNews();
    setNewsList(res.message.slice(0, 9));
  };

  useEffect(() => {
    fetchNews();
  }, []);

  const handleSyncClick = () => {
    fetchNews(); // 동일 함수 재사용
    showAlert("블로그 동기화가 완료되었습니다.");
  };

  return (
    <Div>
      <SeoHead
        title="유학 소식 | 드림유학원"
        description="우즈베키스탄 의대 유학 관련 최신 소식과 입시 정보를 드림유학원이 전해드립니다."
        path="/news"
      />
      <PageHeader title={"소식"} root={"소식"} />

      {role === "admin" && (
        <button onClick={handleSyncClick}>블로그 동기화</button>
      )}
      <Section>
        {newsList &&
          newsList?.map((item, index) => {
            return <NewsCard key={index} {...item} />;
          })}
      </Section>
    </Div>
  );
}
